import React from "react";
import PropTypes from "prop-types";
import { Banner, Text } from "../../../../components";

const BannerPages = ({ subtitle, dataAtualizacao, contentWidth }) => {
  return (
    <Banner
      sectionName="Banner das subpáginas"
      variant="secondary"
      contentWidth={contentWidth}
    >
      <Text size="lg">{subtitle}</Text>

      {dataAtualizacao ? (
        <Text size="lg">{`Última atualização: ${dataAtualizacao}`}</Text>
      ) : null}
    </Banner>
  );
};

BannerPages.defaultProps = {
  dataAtualizacao: null,
  contentWidth: null,
};

BannerPages.propTypes = {
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  dataAtualizacao: PropTypes.instanceOf(Date),
  contentWidth: PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
  }),
};

export default BannerPages;
